import React, {useState} from 'react'
import MobileAppEnableDisableList from './mobileAppEnableDisableList';
import MobileAppEnableDisableForm from './mobileAppEnableDisableForm';

const MobileAppEnableDisable = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");


  return (
    <>
      {fromIsShown ? (
          <MobileAppEnableDisableForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <MobileAppEnableDisableList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default MobileAppEnableDisable
